<template>
    <div style="max-width: 100%;">
        <div style="max-width: 100%;">
            <div style="max-width: 100%;">
                <v-row>
                    <v-col cols="6" style="display: flex; align-items: center;">
                        <span class="font-weight-black text-h7 mr-4">
                            Embarcaciones
                        </span>
                        <v-combobox v-model="selectedEmbarcaciones" :items="embarcaciones" :style="{
                            minWidth: selectedEmbarcaciones.length > 0 ? 'auto' : '200px',
                            maxWidth: selectedEmbarcaciones.length > 0 ? '100%' : '200px'
                        }" placeholder="Embarcaciones" clearable hide-details="true" multiple outlined small-chips
                            @change="getData()" dense></v-combobox>
                    </v-col>
                    <v-col cols="5" style="display: flex; align-items: center;">
                        <span class="font-weight-black text-h7" style="width: 180px;">
                            Fecha de reporte
                        </span>
                        <v-menu v-model="fromDateMenu1" :close-on-content-click="false" offset-y
                            transition="scale-transition" max-width="300px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="formattedDesde" placeholder="Desde" prepend-icon="mdi-calendar"
                                    class="mr-5" clearable dense hide-details="true" outlined readonly
                                    @click:clear="fechaDesde = null; getData()" v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="fechaDesde" locale="es" full-width hide-header color="#05435B"
                                @input="validateFechaDesde"></v-date-picker>
                        </v-menu>
                        <v-menu v-model="fromDateMenu2" :close-on-content-click="false" offset-y
                            transition="scale-transition" max-width="300px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="formattedHasta" placeholder="Hasta" prepend-icon="mdi-calendar"
                                    @click:clear="fechaHasta = null; getData()" class="mr-5" clearable dense outlined
                                    readonly v-on="on" hide-details="true"></v-text-field>
                            </template>
                            <v-date-picker v-model="fechaHasta" locale="es" full-width hide-header color="#05435B"
                                @input="validateFechaHasta"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>

            </div>

        </div>
        <v-divider style="margin-bottom: 10px; margin-top: 10px; max-width: 100%;"></v-divider>
        <div class="d-flex flex-column mb-4" style="max-width: 100%;">
            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="8" style="max-width: 100vw; overflow: hidden;">
                    <v-data-table :mobile-breakpoint="0" :headers="headers" :items="items" class="elevation-1"
                        :items-per-page="15">
                        <template v-slot:item.fechaEngrase="{ item }">
                            <span>
                                {{ item.fechaEngrase == "2000-01-01" ? '' : formatDate(item.fechaEngrase)
                                }}
                            </span>
                        </template>
                        <template v-slot:item.formulario="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon color="red" v-bind="attrs" v-on="on" @click="descargar(item)">
                                        <v-icon>mdi-file-pdf-box</v-icon>
                                    </v-btn>
                                </template>
                                <span>Descargar reporte</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>

        </div>
    </div>
</template>

<script>
import apiService from "@/services/apiService";
import SwalService from '@/services/swalService';
export default {
    data() {
        return {
            expanded: [],
            singleExpand: false,
            selectedEmbarcaciones: [],
            embarcaciones: [
                "ANA LUCIA", "BAMAR I", "BAMAR II", "BAMAR IV", "BAMAR VIII", "CHATA PH1", "CHATA PH5",
                "CHAVELI II", "CHIRA I", "ISABELITA", "IVANA B", "JACKELIN", "JADRANKA B", "KIARA B", "LOMAS"
            ],
            headers: [
                { text: "Embarcación", value: "embarcacion", align: "center" },
                { text: "Responsable", value: "responsable", align: "center" },
                { text: "Fecha de Engrase", value: "fechaEngrase", align: "center" },
                { text: "Formulario", value: "formulario", align: "center" },
            ],
            items: [
                { embarcacion: "ANA LUCIA", responsable: "JUAN CARLOS LEZAMA", fechaEngrase: "2025-02-24" },
                { embarcacion: "BAMAR I", responsable: "JOSEPH HUERTA", fechaEngrase: "2025-01-30" }
            ],
            fromDateMenu1: false,
            fromDateMenu2: false,
            fechaDesde: null,
            fechaHasta: null,
        };
    },
    computed: {
        filteredItems() {
            if (this.selectedEmbarcaciones.length === 0) return this.items;
            return this.items.filter(item => this.selectedEmbarcaciones.includes(item.embarcacion));
        },
        formattedDesde() {
            return this.fechaDesde
                ? new Date(this.fechaDesde + 'T00:00:00').toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                })
                : "";
        },
        formattedHasta() {
            return this.fechaHasta
                ? new Date(this.fechaHasta + 'T00:00:00').toLocaleDateString("es-ES", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                })
                : "";
        },
    },
    created() {
        this.getData();
    },
    methods: {
        validateFechaDesde(value) {
            if (this.fechaHasta && new Date(value) > new Date(this.fechaHasta)) {
                this.fechaDesde = null;
                SwalService.alert("La fecha de inicio no puede ser mayor que la fecha de fin.");
            } else {
                this.fechaDesde = value;
            }
            this.fromDateMenu1 = false;
            this.getData();
        },
        validateFechaHasta(value) {
            if (this.fechaDesde && new Date(value) < new Date(this.fechaDesde)) {
                this.fechaHasta = null;
                SwalService.alert("La fecha de fin no puede ser menor que la fecha de inicio.");
            } else {
                this.fechaHasta = value;

            }
            this.fromDateMenu2 = false;
            this.getData();
        },
        getConditionColor(condition) {
            switch (condition) {
                case "Alerta": return "red";
                case "Precaución": return "orange";
                case "Normal": return "green";
                default: return "grey";
            }
        },
        getDateStyle(date) {
            if (!date) return ""; // Si la fecha es null o undefined, no aplica estilos

            // Convertir la fecha de "yyyy-mm-dd" a un objeto Date
            const [year, month, day] = date.split("-").map(Number);
            const fechaComparar = new Date(year, month - 1, day); // Meses en JavaScript van de 0 a 11

            // Obtener la fecha actual sin hora
            const fechaActual = new Date();
            fechaActual.setHours(0, 0, 0, 0); // Eliminar horas para comparar solo fechas

            // Comparar si la fecha es menor a hoy
            return fechaComparar < fechaActual ? "color: red; font-weight: bold;" : "";
        },

        formatDate(date) {
            if (!date) return ""; // Si la fecha es null o undefined, no mostrar nada

            // Convertir "yyyy-mm-dd" a "dd-mm-yyyy"
            const [year, month, day] = date.split("-");
            return `${day}-${month}-${year}`;
        },

        async getData() {
            SwalService.loading('Cargando..', 'Por favor espere.');
            const parametros = {
                embarcaciones: this.selectedEmbarcaciones,
                fechaInicio: this.fechaDesde,
                fechaFin: this.fechaHasta
            }
            const response = await apiService.post("/engrase/get-historico-engrase", parametros)
            this.items = response.data.controles;

            const response2 = await apiService.get("/engrase/get-embarcacion-engrase-historico");
            if (response2.data.embarcacionList.length > 0) {
                this.embarcaciones = response2.data.embarcacionList;
            } else {
                this.embarcaciones = [];
            }

            SwalService.close();
            await new Promise(resolve => setTimeout(resolve, 100));
        },
        async descargar(item) {
            //const response = await apiService.get("/engrase/get-reporte-pdf")
            try {
                SwalService.loading('Descargando...', 'Por favor espere.');
                await apiService.downloadFile('/engrase/get-reporte-pdf?id=' + item.id, (item.embarcacion + " " + item.fechaEngrase + ".pdf"));
                console.log('Archivo descargado exitosamente.');
                SwalService.close();
            } catch (error) {
                console.error('Error al descargar el archivo:', error);
                SwalService.close();
                SwalService.error('No se pudo descargar el archivo. Intenta nuevamente.');
            }
        }
    }
};
</script>

<style scoped>
/* Estilos mejorados */
.v-data-table {
    border-radius: 10px;
    overflow: hidden;
    font-size: 12px !important;
}

.v-data-table>>>thead th {
    font-size: 13px !important;
    font-weight: bold;
    text-align: center !important;
    color: white !important;
    background-color: #05435B;
}


.v-data-table>>>tbody td {
    font-size: 12px !important;
}

.v-data-table>>>thead th.sortable .v-data-table-header__icon {
    color: white !important;
    font-weight: 700;
}

.switch-container {
    display: flex;
    justify-content: center;
    /* Centrar horizontalmente */
    align-items: center;
    /* Centrar verticalmente */
    padding: 0;
    margin: 0;
}


td {
    text-align: center !important;
    border-bottom: 1px solid #ddd;
    font-size: 14px !important;
}

.table-container {
    display: block;
}

.mobile-table {
    display: none;
}

/* Color para los grupos pares */
.zebra-even {
    background-color: #f2f2f2 !important;
}

/* Color para los grupos impares */
.zebra-odd {
    background-color: #ffffff !important;
}

.v-input--selection-controls__input+.v-label {
    font-size: 12px !important;
}

::v-deep(.v-treeview-node__label) {
    text-align: left !important;
}


.v-treeview-node__children {
    text-align: left;
}

::v-deep(.v-treeview-node__root) {
    min-height: 25px;
}



@media (max-width: 768px) {
    .desktop-table {
        display: none;
    }

    .mobile-table {
        display: block;
    }

    .scrollable-table {
        overflow-x: auto;
        white-space: nowrap;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th,
    td {
        padding: 8px;
        text-align: left;
        border-bottom: 1px solid #ddd;
    }

    .sticky-right {
        position: sticky;
        right: 0;
        background: white;
        z-index: 2;
    }
}
</style>